import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a page_view event to Google Analytics on every client-side route change.
 * GA4's enhanced measurement handles this partially, but explicit tracking
 * is more reliable for SPAs.
 */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

export default RouteTracker;
